import { ActivePlan } from './ActivePlan';
import { PlanSection } from './PlanListv2/main';
import { MainContainer } from './Plans.styles';

const Plans = () => {
  return (
    <MainContainer>
      <ActivePlan />
      {/* <PlanList /> */}
      <PlanSection />
    </MainContainer>
  );
};

export default Plans;
